module.exports = __webpack_public_path__ + "img/agriculture/badge2.3a2ae1c3.png";